<template>
  <div style="width: 900px;" id="szPrintArea" class="fontSong">
    <h3 style="display: flex;justify-content: center; font-weight: 500; font-size: 30px; margin-bottom: 10px;">{{ tableData.pay.titleForDrugstore || '' }}</h3>
      <table cellpadding="0" cellspacing="0" style="width: 100%;font-size: 18px;">
        <tr>
          <td class="widthTitle">药店编码：</td>
          <td class="widthItem">{{ tableData.pay.fixMedinsCode || ''  }}</td>
          <td class="widthTitle">药店名称：</td>
          <td class="widthItem"><div style="margin-right: 10px;">{{ tableData.pay.fixMedinsName || ''  }}</div></td>
          <td class="widthTitle">险种：</td>
          <td class="widthItem">{{ tableData.pay.insutypeName || ''  }}</td>
        </tr>
        <tr>
          <td class="widthTitle">就诊流水号：</td>
          <td class="widthItem">{{ tableData.pay.mdtrtId || ''  }}</td>
          <td class="widthTitle">购药人姓名：</td>
          <td class="widthItem">{{ tableData.pay.patientName || ''  }}</td>
          <td class="widthTitle">销售单号：</td>
          <td class="widthItem">{{ tableData.pay.saleOrderNo || ''  }}</td>
        </tr>
        <tr>
          <td class="widthTitle" style="height: 40px;">结算业务号：</td>
          <td class="widthItem">{{ tableData.pay.setlId || ''  }}</td>
          <td class="widthTitle">人员编号：</td>
          <td class="widthItem">{{ tableData.pay.psnNo || ''  }}</td>
          <td class="widthTitle">业务类别：</td>
          <td class="widthItem">{{ tableData.pay.medTypeName || ''  }}</td>
        </tr>
      </table>
    <div style="width: 100%;">
      <table cellpadding="0" cellspacing="0" style="width:100%;border:1px solid black;font-size: 18px;">
        <tr>
          <td class='BB BR' style="height: 30px; width: 10%;">项目</td>
          <td class='BB BR' style="height: 30px; width: 12%">金额（元）</td>
          <td class='BB BR' style="height: 30px; width: 21%">明细名称</td>
          <td class='BB BR' style="height: 30px; width: 9%">商品编码</td>
          <td class='BB BR' style="height: 30px; width: 11%">批号</td>
          <td class='BB BR' style="height: 30px; width: 11%">规格</td>
          <td class='BB BR' style="height: 30px; width: 7%">数量</td>
          <td class='BB BR' style="height: 30px; width: 8%">单价</td>
          <td class='BB' style="height: 30px; width: 7%">金额</td>
        </tr>
        <tr>
          <td colspan="2" class='BB BR' style="height: 55px;">
            <div style="display: flex; justify-content: space-between;">
              <div style="margin-left:5px">西药费：</div>
              <div class="mrginRight3">{{ fix(tableData.pay.westernDrugAmt) }}</div>
            </div>
            <div style="display: flex; justify-content: space-between;">
              <div style="margin-left:5px">中成药费：</div>
              <div class="mrginRight3">{{ fix(tableData.pay.chinesePatentDrugAmt) }}</div>
            </div>
          </td>
          <td colspan="7" rowspan="5" class='BB'>
            <div class="recipe">
              <table cellpadding="0" cellspacing="0" style="width: 100%;font-size: 16px;">
                <tr v-for="item in tableData.receipt.saleOrderDetailList">
                  <td style="width:30%; text-align: left;"><div style="margin-left: 5px;">{{ item.approvedDrugNames || ''}}{{ `(${item.goodsName})` }}</div></td>
                  <td style="width:9%; text-align: left;"><div style="margin-left: 5px;">{{ item.drugSerialCode }}</div></td>
                  <td style="width:15%; text-align: left;"><div style="margin-left: 5px;">{{ item.goodsLot }}</div></td>
                  <td style="width:16%; text-align: left;"><div style="margin-left: 5px;">{{ item.specifications }}</div></td>
                  <td style="width:10%; text-align: center;"><div style="margin-left: 5px;">{{ item.goodsCount }}</div></td>
                  <td style="width:10%; text-align: right;"><div style="margin-right: 5px;">{{ fix(item.realPrice) }}</div></td>
                  <td style="width:10%; text-align: right;"><div style="margin-right: 5px;">{{ fix(item.amountWithoutDiscountDisplay) }}</div></td>
                </tr>
              </table>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2" class='BB BR' style="height: 45px;">
            <div style="display: flex; justify-content: space-between;">
              <div style="margin-left:5px">费用合计：</div>
              <div class="mrginRight3">{{fix(tableData.pay.totalAmt)}}</div>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2" class='BB BR' style="height: 45px;">
            <div style="display: flex; justify-content: space-between;">
              <div style="margin-left:5px">基金支付：</div>
              <div class="mrginRight3">{{ fix(tableData.pay.fundPaySumamt) }}</div>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2" class='BB BR' style="height: 45px;">
            <div style="display: flex; justify-content: space-between;">
              <div style="margin-left:5px">个人账户：</div>
              <div class="mrginRight3">{{ fix(tableData.pay.acctPay) }}</div>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2" class='BB BR' style="height: 45px;">
            <div style="display: flex; justify-content: space-between;">
              <div style="margin-left:5px">现金支付：</div>
              <div class="mrginRight3">{{ fix(tableData.pay.cashPayamt) }}</div>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="9" style="height: 55px;">
            <div style="display: flex;flex-direction: column; height: 40px; flex-wrap:wrap; justify-content: flex-start;align-items:flex-start">
              <div style="margin-left: 5px;">实收金额：{{fix(tableData.receipt.saleOrder.proceedsAmount || 0)}}</div>
              <div style="margin-left: 5px;">找零金额：{{ fix(tableData.receipt.saleOrder.proceedsChange) }}</div>
              <div style="left: -200px !important;position: relative;margin-left: 3px;">个人账户余额：{{ fix(tableData.pay.balc) }}</div>
            </div>
          </td>
        </tr>
      </table>
      <div style="margin-top: 10px;">
        <span style="font-size: 18px; margin-left: 5px;">收银员：{{ tableData.pay.createUserName }}</span>
        <span style="font-size: 18px; margin-left: 623px;">日期：{{ tableData.pay.setlTime ? tableData.pay.setlTime.split(' ')[0] : '' }}</span>
      </div>
    </div>
  </div>
</template>
<script>

import '@/assets/font.css';
import utils from '../../libs/utils';

export default {
  name: "shenzhenPrintModel",
  data() {
    return {
      tableData: { pay: {}, receipt: { saleOrder: {}, saleOrderDetailList: [] } },
    };
  },
  methods: {
    handlePrint() {
      console.log('数据', this.tableData);
      let dom = document.querySelector('#szPrintArea');
      dom.style.display = 'block';
      this.$print(dom);
    },
    fix(value) {
      return utils.toFixed(value, 2, true);
    },
  },
};
</script>
<style lang="less" scoped>
#szPrintArea td {
  text-align: center;
  height: 24px;
}
.mrginRight3 {
  margin-right: 3px;
}
.BR {
  border-right:solid #000 1px;
}
.BB {
  border-bottom:solid #000 1px;
}
.fontSong {
  font-family:"SongTi";
}
.recipe {
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  height: 270px;
  margin-top: 3px;
}
.recipeItem {
  display: flex;
  justify-content: space-between !important;
  align-content: flex-start;
  font-size: 17px;
}
.widthTitle {
  width: 13%;
  text-align:left !important;
}
.widthItem {
  width: 20.3%;
  text-align:left !important;
}
</style>
